/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_SickLeaveApplicationResponse_ } from '../models/BaseDataResponse_SickLeaveApplicationResponse_';
import type { BaseListDataResponse_SickLeaveApplicationResponse_ } from '../models/BaseListDataResponse_SickLeaveApplicationResponse_';
import type { CreateMySickLeaveApplicationRequest } from '../models/CreateMySickLeaveApplicationRequest';
import type { SickLeaveApplicationStatus } from '../models/SickLeaveApplicationStatus';
import type { UpdateSickLeaveApplicationStatusRequest } from '../models/UpdateSickLeaveApplicationStatusRequest';
import type { UpdateSickLeaveEndDateRequest } from '../models/UpdateSickLeaveEndDateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SickLeaveApplicationsService {
    /**
     * List My Sick Leave Applications
     * Получение списка своих заявок на больничный
     * @param status Фильтр по статусу
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMySickLeaveApplicationsApiSickLeaveApplicationsMeGet(
        status?: (SickLeaveApplicationStatus | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sick_leave/applications/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Sick Leave Application
     * Создание заявки на больничный от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMySickLeaveApplicationApiSickLeaveApplicationsMePost(
        requestBody: CreateMySickLeaveApplicationRequest,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/sick_leave/applications/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Sick Leave Application
     * Получение своей заявки на больничный по ID
     * @param applicationId
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMySickLeaveApplicationApiSickLeaveApplicationsMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sick_leave/applications/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: base_error`,
                401: `Code: authentication_error`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Extend My Sick Leave Application
     * Продление больничного от имени текущего пользователя
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static extendMySickLeaveApplicationApiSickLeaveApplicationsMeApplicationIdExtendPut(
        applicationId: string,
        requestBody: UpdateSickLeaveEndDateRequest,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/sick_leave/applications/me/{application_id}/extend',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: base_error`,
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List Sick Leave Applications
     * Получение списка заявок на больничный с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param startDateFrom Фильтр по дате начала (от)
     * @param startDateTo Фильтр по дате начала (до)
     * @param endDateFrom Фильтр по дате окончания (от)
     * @param endDateTo Фильтр по дате окончания (до)
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listSickLeaveApplicationsApiSickLeaveApplicationsGet(
        status?: (SickLeaveApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        startDateFrom?: (string | null),
        startDateTo?: (string | null),
        endDateFrom?: (string | null),
        endDateTo?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sick_leave/applications',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'start_date_from': startDateFrom,
                'start_date_to': startDateTo,
                'end_date_from': endDateFrom,
                'end_date_to': endDateTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Sick Leave Application
     * Получение заявки на больничный по ID
     * @param applicationId
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getSickLeaveApplicationApiSickLeaveApplicationsApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sick_leave/applications/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: base_error`,
                401: `Code: authentication_error`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Sick Leave Application Status Endpoint
     * Обновление статуса заявки на больничный
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateSickLeaveApplicationStatusEndpointApiSickLeaveApplicationsApplicationIdStatusPut(
        applicationId: string,
        requestBody: UpdateSickLeaveApplicationStatusRequest,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/sick_leave/applications/{application_id}/status',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: base_error`,
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Admin Extend Sick Leave Application
     * Продление больничного администратором/бухгалтером
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_SickLeaveApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static adminExtendSickLeaveApplicationApiSickLeaveApplicationsApplicationIdExtendPut(
        applicationId: string,
        requestBody: UpdateSickLeaveEndDateRequest,
    ): CancelablePromise<BaseDataResponse_SickLeaveApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/sick_leave/applications/{application_id}/extend',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: base_error`,
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
